module.exports = new __parcel__URL__("trach_x2.235d8ef1.webp").toString();